import React from 'react'

const SoftwareBox = (props) => {
    return (
        <>
            <div className="col-md-4">
    <div className="border rounded text-center p-3 height mt-3">
        {props.font}
    <h3 className='text-primary font-weight-bold'>{props.head}</h3>
    <p className="text-justify">{props.para}</p>

    </div>
</div>
        </>
    )
}

export default SoftwareBox
